import { UserX } from "lucide-react";
import { useImpersonation } from "@/lib/auth/ImpersonationContext";
import { Button } from "@/components/ui/Button";

/**
 * Barre persistante affichée en haut de l'écran lorsqu'un admin
 * est en mode impersonation. Permet de quitter le mode en un clic.
 */
export function ImpersonationBar() {
  const { impersonated, stopImpersonating, busy } = useImpersonation();

  if (!impersonated) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 bg-warning px-4 py-2 text-sm font-medium text-warning-foreground shadow-sm"
    >
      <div className="flex items-center gap-2">
        <UserX className="size-4 shrink-0" />
        <span>
          Session de diagnostic : <strong>{impersonated.displayName || impersonated.email}</strong>
          {impersonated.email && impersonated.displayName ? (
            <span className="ml-1 font-normal opacity-75">({impersonated.email})</span>
          ) : null}
          <span className="block text-xs">
            Les modifications sont réelles. Votre compte reste disponible dans les autres onglets.
          </span>
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={stopImpersonating}
        loading={busy}
        disabled={busy}
        className="shrink-0 border border-warning-foreground/30 text-warning-foreground hover:bg-warning-foreground/10"
      >
        Revenir à mon compte
      </Button>
    </div>
  );
}
